/** Stable demo user sentinel; comparing identities must not load the fixture graph. */
export const USER_ID = 'demo-user';
